import { render, staticRenderFns } from "./UsersPrivilegeTransactionPointsHistory.vue?vue&type=template&id=6b92ef97&scoped=true&"
import script from "./UsersPrivilegeTransactionPointsHistory.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeTransactionPointsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b92ef97",
  null
  
)

export default component.exports